import type { PartnerFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

import _t from 'i18n!nls/xdp';

const getSEODescription = (
  description: string,
  partners?: Array<PartnerFragment> | null,
  enableCoBranding?: boolean
): string => {
  if (partners && partners?.length > 1 && enableCoBranding) {
    return _t(`Offered by #{firstPartnerName} and #{secondPartnerName}. #{description}`, {
      // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      firstPartnerName: partners[0].name,
      // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      secondPartnerName: partners[1].name,
      description,
    });
  } else if (partners?.length === 1) {
    return _t(`Offered by #{firstPartnerName}. #{description}`, {
      // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      firstPartnerName: partners[0].name,
      description,
    });
  } else {
    return description;
  }
};

export default getSEODescription;
